/***
 *
 *   STAT STYLES
 *   Ported from ui-reference/src/components/layouts/stat-card.tsx.
 *
 *   The reference's StatCard is its own bordered surface — icon well on the
 *   left, label above value on the right — so Stat no longer nests inside a
 *   Card. The previous layout put a faint icon circle behind the value.
 *
 **********/

const Style = {
    base: 'rounded-lg border bg-surface p-4 shadow-sm',
    row: 'flex items-center gap-3',
    iconWell: 'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
    body: 'min-w-0',
    label: 'text-xs font-medium text-text-secondary',
    valueRow: 'flex items-baseline gap-2',
    value: 'text-2xl font-bold text-text-primary',
    change: 'inline-flex items-center gap-0.5 text-xs font-medium',
    changeUp: 'text-success',
    changeFlat: 'text-text-muted',
    changeDown: 'text-error',
};

/**
 * Icon-well tints. The reference uses `bg-primary-100 text-primary-600` as its
 * default and does not offer a palette; these keys exist because this app's
 * stat rows colour-code each tile. `purple` and `pink` used raw Tailwind
 * palette classes before — they now resolve to tokens.
 */
export const ICON_TINTS = {
    blue: 'bg-primary-100 text-primary-600 dark:bg-primary-900/50 dark:text-primary-200',
    purple: 'bg-accent-100 text-accent-700 dark:bg-accent-900/50 dark:text-accent-200',
    pink: 'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',
    green: 'bg-success/10 text-success',
    red: 'bg-error/10 text-error',
    orange: 'bg-warning/10 text-warning',
    yellow: 'bg-warning/10 text-warning',
};

export default Style;
